// src/features/dashboard/services/heatmap.service.ts

import api from '../../../api/apiService';
import { ENDPOINTS } from '../../../api/endpoints';
import type { HeatmapApiRow, HeatmapRequest } from '../types/heatmap.types';

export const getHeatmapData = async (
  payload: HeatmapRequest,
): Promise<HeatmapApiRow[]> => {
  const response = await api.post(
    ENDPOINTS.HEATMAP,
    payload,
  );

  return response.data;
};